import React, { useState } from "react";
import { Star, StarHalf } from "lucide-react";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Footer from "../components/Footer";

const allReviews = [
  {
    name: "Mustafa Korkmaz",
    region: "Ostim Halı Yıkama",
    comment: "Ostim'de halılarımı ilk defa bu kadar iyi temizleten bir firma buldum.",
    stars: 5,
  },
  {
    name: "Necla Demir",
    region: "Ostim Koltuk Yıkama",
    comment: "Koltuklardaki yağ lekeleri bile çıkmış. Hizmet gayet başarılıydı.",
    stars: 4.5,
  },
  {
    name: "Ayhan Altun",
    region: "Ostim Yorgan Yıkama",
    comment: "Yorganlar pırıl pırıl geldi. Paketleme ve zamanlama çok iyi.",
    stars: 5,
  },
  {
    name: "Bahar Çelik",
    region: "Ostim Yerinde Koltuk Yıkama",
    comment: "Evde yerinde yıkama sayesinde koltuklar çok kısa sürede temizlendi.",
    stars: 4,
  },
  {
    name: "Melek Yıldırım",
    region: "Ostim Perde Yıkama",
    comment: "Perdeler tertemiz ve kırışmadan geldi. Teşekkür ederim.",
    stars: 5,
  },
  {
    name: "Murat Yılmaz",
    region: "Ostim Battaniye Yıkama",
    comment: "Battaniyeler çok güzel kokuyordu ama 1 gün geç teslim edildi.",
    stars: 4.5,
  },
  {
    name: "Sevda Ersoy",
    region: "Ostim Halı Yıkama",
    comment: "Halılar hem temizdi hem de çok düzenli paketlenmişti.",
    stars: 5,
  },
  {
    name: "Erkan Turgut",
    region: "Ostim Koltuk Yıkama",
    comment: "Çalışanlar çok saygılı ve işlerini iyi yapıyorlar.",
    stars: 4,
  },
  {
    name: "Zeliha Koç",
    region: "Ostim Perde Yıkama",
    comment: "Güvenilir firma. Perdeler kusursuz şekilde temizlenmişti.",
    stars: 5,
  },
  {
    name: "Yunus Polat",
    region: "Ostim Halı Yıkama",
    comment: "Hızlı teslimat, tertemiz sonuç. Herkese tavsiye ederim.",
    stars: 5,
  },
];

const renderStars = (count) => {
  const fullStars = Math.floor(count);
  const halfStar = count % 1 !== 0;
  const starsArray = [];
  for (let i = 0; i < fullStars; i++) {
    starsArray.push(<Star key={i} size={16} fill="gold" stroke="gold" />);
  }
  if (halfStar) {
    starsArray.push(<StarHalf key="half" size={16} fill="gold" stroke="gold" />);
  }
  return <div className="flex gap-1">{starsArray}</div>;
};

const OstimReviews = () => {
  const [visibleCount, setVisibleCount] = useState(5);
  const showMore = () => setVisibleCount(visibleCount + 10);
  const openLoginModal = () => alert("Lütfen üye girişi için firmamızla iletişime geçin.");

  return (
    <>
      <div className="bg-white w-full pt-5 px-4 sm:px-6 mx-auto">
        <div className="w-full mb-6">
          <img
            src="/images/8.png"
            alt="Mobil Yorum Görseli"
            loading="lazy"
            className="block sm:hidden w-full h-auto object-cover"
          />
          <img
            src="/images/slider1.png"
            alt="Masaüstü Slider Görseli"
            loading="lazy"
            className="hidden sm:block w-full h-auto object-cover"
          />
        </div>

        <h1 className="font-luckiest text-4xl text-center text-black drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">
          OSTİM HALI YIKAMA
        </h1>

        <h1 className="text-center text-xl sm:text-2xl font-semibold text-[#003132] mt-4 mb-8">
          Ostim bölgesinde hizmet verdiğimiz bazı müşterilerimizin yorumları
        </h1>
      </div>

      <div className="bg-white py-0 px-6 max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {allReviews.slice(0, visibleCount).map((review, index) => (
            <div key={index} className="border rounded-xl p-3 shadow-sm hover:shadow-md transition">
              <div className="flex items-center gap-2 mb-2">
                <img src="/images/google.png" alt="Google" className="w-5 h-5 mr-2" />
                <span className="font-semibold">{review.name}</span>
              </div>
              <div className="text-sm text-gray-600 mb-1">{review.region}</div>
              {renderStars(review.stars)}
              <p className="mt-2 text-sm">{review.comment}</p>
            </div>
          ))}
        </div>

        {visibleCount < allReviews.length && (
          <div className="text-center mt-8">
            <button
              onClick={showMore}
              className="bg-[#003132] text-white px-4 py-2 rounded hover:bg-[#004950] transition"
            >
              Diğer Yorumları Göster
            </button>
          </div>
        )}

        {visibleCount >= allReviews.length && (
          <div className="text-center mt-4">
            <button
              onClick={openLoginModal}
              className="text-[#003132] underline text-sm"
            >
              Tüm yorumları görmek için tıklayın
            </button>
          </div>
        )}
      </div>

      <ServicesGrid />
      <BlogList />
      <Footer />
    </>
  );
};

export default OstimReviews;
